module.exports = __webpack_public_path__ + "static/media/ADC3.de3df1d4.svg";